import { http } from '@pendo/http';
import keyBy from 'lodash/keyBy';

export async function getItemsWithSummaries (itemsWithoutSummaries) {
    const response = await http.post('api/s/_SID_/getItemSummary', { items: itemsWithoutSummaries });

    return keyBy(response.data, 'id');
}

export async function getNextRightActions (pbo) {
    const endpointTranslation = {
        DRIVE_PRODUCT_ADOPTION: 'productAdoption',
        ONBOARD_AND_TRAIN_USERS: 'onboarding',
        IMPROVE_CUSTOMER_HEALTH: 'health',
        PRODUCT_PLANNING_AND_INNOVATION: 'planning',
        IMPROVE_CONVERSION_RATES: 'conversion',
        NOT_SURE: 'notSure',
    };

    return http.get(`api/s/_SID_/nextRightAction/${endpointTranslation[pbo]}`).then((res) => res.data);
}

export async function getAiInsights () {
    const response = await http.get('api/s/_SID_/insights/card');

    return response.data;
}
